import { ArrowUpRight, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { MILESTONE_STATUSES, milestones, milestoneSummary } from "@/data/milestones";

const summaryItems = [
  ["Milestones", milestones.length],
  ["Completed", milestoneSummary.completed],
  ["In Progress", milestoneSummary.inProgress],
  ["Planned", milestoneSummary.planned],
];

function StatusBadge({ milestone }) {
  const status = MILESTONE_STATUSES[milestone.status];
  return <span className={`milestone-status milestone-status-${milestone.status}`} data-testid={`milestone-status-${milestone.slug}`}>{status.label}</span>;
}

export default function UpdatesPage() {
  const completion = (milestoneSummary.completed / milestones.length) * 100;
  return (
    <main className="updates-page" data-testid="updates-page">
      <section className="updates-masthead">
        <div className="updates-inner">
          <p className="eyebrow eyebrow-amber">Vmemoo / Updates</p>
          <h1>Building Vmemoo.</h1>
          <p>Milestones, releases and what we&apos;re building next. Follow Vmemoo&apos;s journey from an idea to a growing platform for preserving the people, pets and moments that matter.</p>
        </div>
      </section>
      <section className="updates-summary-section" aria-label="Vmemoo roadmap progress">
        <div className="updates-inner">
          <div className="updates-summary" data-testid="updates-progress-summary">
            {summaryItems.map(([label, count]) => <div className="updates-stat" key={label} data-testid={`updates-stat-${label.toLowerCase().replaceAll(" ", "-")}`}><strong>{count}</strong><span>{label}</span></div>)}
          </div>
          <div className="updates-progress-wrap">
            <div className="updates-progress-copy"><span>{milestoneSummary.completed} of {milestones.length} milestones completed</span><span>{completion.toFixed(1)}%</span></div>
            <div className="updates-progress" role="progressbar" aria-label="Milestones completed" aria-valuemin="0" aria-valuemax={milestones.length} aria-valuenow={milestoneSummary.completed} data-testid="updates-progress-indicator"><span style={{ width: `${completion}%` }} /></div>
          </div>
        </div>
      </section>
      <section className="updates-timeline-section" aria-labelledby="updates-timeline-heading">
        <div className="updates-inner">
          <div className="updates-timeline-heading"><p className="section-label">The journey so far</p><h2 id="updates-timeline-heading">Milestones, in progress.</h2></div>
          <ol className="updates-timeline" data-testid="updates-timeline">
            {milestones.map((milestone) => <li key={milestone.slug} className="updates-entry" data-testid={`milestone-card-${milestone.slug}`}>
              <Link to={`/updates/${milestone.slug}`} className="updates-entry-link" data-testid={`milestone-link-${milestone.slug}`}>
                <span className="updates-entry-number">{String(milestone.number).padStart(2, "0")} / {milestones.length}</span>
                <div className="updates-entry-copy"><div className="updates-entry-meta"><StatusBadge milestone={milestone} />{milestone.date && <span className="updates-date">{milestone.date}</span>}</div><h3>{milestone.title}</h3><p>{milestone.shortDescription}</p></div>
                <ArrowUpRight className="updates-entry-arrow" size={19} aria-hidden="true" />
              </Link>
            </li>)}
          </ol>
        </div>
      </section>
      <section className="updates-vision-section" aria-labelledby="updates-vision-heading" data-testid="updates-vision-section">
        <div className="updates-inner updates-vision-inner">
          <div><p className="section-label">The Vmemoo Vision</p><p className="updates-vision-meta">PDF · 2026 Edition</p></div>
          <div className="updates-vision-copy"><h2 id="updates-vision-heading">Want to know more about what we&apos;re building?</h2><p>A deeper look at Vmemoo, why it exists, how the platform works and where we&apos;re going.</p><a className="updates-vision-download" href="/assets/vmemoo/documents/The_Vmemoo_Vision_2026.pdf" download="The_Vmemoo_Vision_2026.pdf" type="application/pdf" data-testid="updates-vision-download-link"><Download size={17} aria-hidden="true" /> Download The Vmemoo Vision 2026</a></div>
        </div>
      </section>
    </main>
  );
}